import React, { useEffect } from 'react';
import { Redirect, Link as LinkDom } from 'react-router-dom';
import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Hidden from '@material-ui/core/Hidden';
import Poppers from '@material-ui/core/Popper';
// @material-ui/icons
import Person from '@material-ui/icons/Person';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/Help';

import Notifications from '@material-ui/icons/Notifications';
// core components
import Button from 'components/CustomButtons/Button';
import { Dialog as DialogPrime } from 'primereact/dialog';
import TextField from '@material-ui/core/TextField';

import styles from 'assets/jss/material-dashboard-react/components/headerLinksStyle';
import Link from '@material-ui/core/Link';
import { dominioDemandaCirurgica } from '../../config/database';
import 'assets/css/geral.css';

const useStyles = makeStyles(styles);

export default function AdminNavbarLinks() {
  const classes = useStyles();
  const [openNotification, setOpenNotification] = React.useState(null);
  const [openProfile, setOpenProfile] = React.useState(null);
  const [redirecionaLogout, setLogout] = React.useState(false);
  const [linkRedirecionamento, setLinkRedirecionamento] = React.useState(null);
  const [arrayLinkRedirecionamento, setArrayLinkRedirecionamento] = React.useState([]);
  const [totalPendente, setTotalPendente] = React.useState(0);
  const [openInformarProblema, setOpenInformarProblema] = React.useState(false);
  const [problemaInformado, setProblemaInformado] = React.useState('');

  useEffect(() => {
    const profissional = JSON.parse(localStorage.getItem('profissional'));
    if (profissional) {
      if (profissional.areaTecnica_id !== 0) {
        dominioDemandaCirurgica
          .get(`/api/pendenciaParecer/${profissional.profissional_id}`)
          .then(res => {
            setTotalPendente(res.data.total);
          });
      }
    }
  }, []);

  useEffect(() => {
    setArrayLinkRedirecionamento([...arrayLinkRedirecionamento, linkRedirecionamento]);
  }, [linkRedirecionamento]);

  const handleLogout = async () => {
    setLogout(true);
  };

  const handleClickNotification = event => {
    if (openNotification && openNotification.contains(event.target)) {
      setOpenNotification(null);
    } else {
      setOpenNotification(event.currentTarget);
    }
  };
  const handleCloseNotification = () => {
    setOpenNotification(null);
  };
  const handleClickProfile = event => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };
  const handleCloseProfile = () => {
    setOpenProfile(null);
  };

  const handleOpenInformarProblema = () => {
    setOpenInformarProblema(true);
  };

  const handleCloseInformarProblema = () => {
    setProblemaInformado(null);
    setOpenInformarProblema(false);
  };

  const handleEnviarProblemaInformado = e => {
    e.preventDefault();

    const profissional = JSON.parse(localStorage.getItem('profissional'));
    const emailProblemaInformado = `${profissional.nome}<br/><br/>${problemaInformado}`;

    dominioDemandaCirurgica
      .post('/api/enviarEmailInformarProblema', { problemaInformado: emailProblemaInformado })
      .then(() => {
        setProblemaInformado(false);
        setOpenInformarProblema(false);
      });
  };

  const handleClickNotificacaoCheckList = () => {
    setOpenNotification(null);
    setLinkRedirecionamento('/admin/checkListGeral');
  };

  const handleClickTrocarSenha = () => {
    setOpenProfile(null);
    setLinkRedirecionamento('/admin/alterarsenha');
  };

  if (redirecionaLogout) {
    localStorage.clear();
    return <Redirect from="/" to="/login" />;
  }

  const handleRedirect = () => {
    if (linkRedirecionamento) {
      return <Redirect from="/" to={linkRedirecionamento} />;
    }
    return null;
  };

  return (
    <div>
      {handleRedirect()}
      <DialogPrime
        header="Informar um Problema"
        visible={openInformarProblema}
        style={{ width: '65vw' }}
        onHide={() => handleCloseInformarProblema()}
      >
        <form onSubmit={e => handleEnviarProblemaInformado(e)} style={{ overflow: 'hidden' }}>
          <TextField
            id="descricaoParecer"
            multiline
            onChange={e => {
              setProblemaInformado(e.target.value);
            }}
            style={{ marginBottom: '20px', marginTop: '10px', textAlign: 'left' }}
            inputProps={{ maxLength: '300' }}
            label="Descreva o erro de maneira mais clara possível para que ele possa ser reproduzido novamente e corrigido."
            variant="outlined"
            fullWidth
            required
            rows={3}
          />
          <div style={{ float: 'right' }}>
            <Button
              variant="contained"
              color="danger"
              onClick={() => handleCloseInformarProblema()}
            >
              Cancelar
            </Button>
            <Button variant="contained" color="info" type="submit">
              Confirmar
            </Button>
          </div>
        </form>
      </DialogPrime>
      <div id="barra-superior">
        <div className={classes.manager}>
          <Tooltip title="Tire suas dúvidas no Blog do Opera">
            <IconButton onClick={() => window.open('http://operabloghc.famema.br/', '_blank')}>
              <HelpIcon />
            </IconButton>
          </Tooltip>
          <Button
            color={window.innerWidth > 959 ? 'transparent' : 'white'}
            justIcon={window.innerWidth > 959}
            simple={!(window.innerWidth > 959)}
            aria-owns={openNotification ? 'notification-menu-list-grow' : null}
            aria-haspopup="true"
            onClick={handleClickNotification}
            className={classes.buttonLink}
          >
            <Notifications className={classes.icons} style={{ zIndex: 100 }} />
            <span className={classes.notifications}>{totalPendente}</span>
            <Hidden mdUp implementation="css">
              <Link onClick={handleCloseNotification} className={classes.linkText}>
                Notification
              </Link>
            </Hidden>
          </Button>

          <Poppers
            open={Boolean(openNotification)}
            anchorEl={openNotification}
            transition
            disablePortal
            className={`${classNames({ [classes.popperClose]: !openNotification })} ${
              classes.popperNav
            }`}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="notification-menu-list-grow"
                style={{
                  transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleCloseNotification}>
                    <MenuList role="menu">
                      {/* <MenuItem
                        className={classes.dropdownItem}
                        onClick={handleClickNotificacaoCheckList}
                      >
                        {`Você tem ${totalPendente} pedidos sem avaliação técnica`}
                      </MenuItem> */}
                      <LinkDom
                        to="/admin/pareceresAreaTecnica"
                        onClick={() => handleCloseNotification}
                      >
                        <MenuItem className={classes.dropdownItem}>
                          {`Você tem ${totalPendente} pedidos sem avaliação técnica`}
                        </MenuItem>
                      </LinkDom>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Poppers>
        </div>
        <div className={classes.manager}>
          <Button
            color={window.innerWidth > 959 ? 'transparent' : 'white'}
            justIcon={window.innerWidth > 959}
            simple={!(window.innerWidth > 959)}
            aria-owns={openProfile ? 'profile-menu-list-grow' : null}
            aria-haspopup="true"
            onClick={handleClickProfile}
            className={classes.buttonLink}
          >
            <Person className={classes.icons} />
            <Hidden mdUp implementation="css">
              <p className={classes.linkText}>Perfil</p>
            </Hidden>
          </Button>
          <Poppers
            open={Boolean(openProfile)}
            anchorEl={openProfile}
            transition
            disablePortal
            className={`${classNames({ [classes.popperClose]: !openProfile })} ${
              classes.popperNav
            }`}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                id="profile-menu-list-grow"
                style={{
                  transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleCloseProfile}>
                    <MenuList role="menu">
                      <MenuItem
                        onClick={() => {
                          handleOpenInformarProblema();
                        }}
                        className={classes.dropdownItem}
                      >
                        Informar um Problema
                      </MenuItem>
                      <LinkDom to="/admin/alterarsenha" onClick={() => handleCloseProfile}>
                        <MenuItem className={classes.dropdownItem} onClick={handleClickTrocarSenha}>
                          Redefinir Senha
                        </MenuItem>
                      </LinkDom>
                      <MenuItem onClick={handleLogout} className={classes.dropdownItem}>
                        Sair
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Poppers>
        </div>
      </div>
    </div>
  );
}
